<template>
  <AiEducationLayout>
    <EducationPageHeader
      title="孩子作业"
      description="只读查看当前监护关系内孩子的作业与批改状态"
    />
    <ContentWrap>
      <EducationState v-if="state === 'loading'" state="loading" title="正在加载孩子作业" />
      <EducationState
        v-else-if="state === 'error'"
        state="error"
        title="孩子作业加载失败"
        description="请确认监护关系仍然有效。"
        @retry="load"
      />
      <EducationState
        v-else-if="!assignments.length"
        state="empty"
        title="暂无作业"
        description="教师发布作业后会显示在这里。"
      />
      <el-table v-else :data="assignments" row-key="id" stripe>
        <el-table-column prop="title" label="作业" min-width="220" />
        <el-table-column label="截止时间" width="180"
          ><template #default="{ row }">{{ formatDate(row.dueTime) }}</template></el-table-column
        >
        <el-table-column label="状态" width="110"
          ><template #default="{ row }"
            ><el-tag :type="statusType(row)">{{ statusText(row) }}</el-tag></template
          ></el-table-column
        >
        <el-table-column label="得分" width="100"
          ><template #default="{ row }">{{ row.score ?? '—' }}</template></el-table-column
        >
        <el-table-column prop="teacherFeedback" label="教师反馈" min-width="220"
          ><template #default="{ row }">{{ row.teacherFeedback || '—' }}</template></el-table-column
        >
      </el-table>
    </ContentWrap>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AiEducationLayout from '../layout/AiEducationLayout.vue'
import EducationPageHeader from '../components/EducationPageHeader.vue'
import EducationState from '../components/EducationState.vue'
import { getParentChildAssignments, type ParentChildAssignmentVO } from '@/api/aiEducation'

defineOptions({ name: 'AiEducationParentAssignments' })
const route = useRoute()
const assignments = ref<ParentChildAssignmentVO[]>([])
const state = ref<'loading' | 'ready' | 'error'>('loading')
const load = async () => {
  const studentId = Number(route.query.studentId)
  if (!studentId) {
    state.value = 'error'
    return
  }
  state.value = 'loading'
  try {
    assignments.value = (await getParentChildAssignments(studentId)) || []
    state.value = 'ready'
  } catch {
    state.value = 'error'
  }
}
const formatDate = (value?: string) => (value ? new Date(value).toLocaleString() : '未设置')
const statusText = (row: ParentChildAssignmentVO) =>
  row.expired && row.submissionStatus == null
    ? '已逾期'
    : row.submissionStatus == null
      ? '待完成'
      : row.submissionStatus >= 30
        ? '已批改'
        : row.submissionStatus >= 10
          ? '已提交'
          : '草稿'
const statusType = (row: ParentChildAssignmentVO) => {
  const status = row.submissionStatus ?? 0
  return row.expired && !status
    ? 'danger'
    : status >= 30
      ? 'success'
      : status >= 10
        ? 'info'
        : 'warning'
}
onMounted(load)
</script>
